import React, { useState } from 'react';
import { siteInfo, galleryImages } from '../data/mockData';
import { MapPin, Mail, Phone } from 'lucide-react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Message sent successfully! (Mock submission)');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <section id="contact" className="bg-black py-24">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <h2 className="text-3xl font-bold text-white text-center mb-4 tracking-[0.15em]" style={{ fontFamily: 'Georgia, serif' }}>
          FEEL FREE TO ASK ANYTHING
        </h2>
        <p className="text-gray-400 text-center mb-16 text-sm">
          You can book an appointment or leave us a message and we will contact you back
        </p>

        <div className="grid lg:grid-cols-2 gap-20">
          {/* Contact Info & Form */}
          <div>
            {/* Contact Details */}
            <div className="space-y-5 mb-12">
              <div className="flex items-start space-x-4 text-gray-300">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span className="text-sm">{siteInfo.address}</span>
              </div>
              <div className="flex items-center space-x-4 text-gray-300">
                <Mail size={18} className="flex-shrink-0" />
                <a href={`mailto:${siteInfo.email}`} className="hover:text-white transition-colors text-sm">
                  {siteInfo.email}
                </a>
              </div>
              <div className="flex items-center space-x-4 text-gray-300">
                <Phone size={18} className="flex-shrink-0" />
                <a href={`tel:${siteInfo.phone}`} className="hover:text-white transition-colors text-sm">
                  {siteInfo.phone}
                </a>
              </div>
            </div>

            {/* Contact Form */}
            <form onSubmit={handleSubmit} className="space-y-8">
              <div>
                <label className="text-white text-sm mb-2 block">Your name<span className="text-red-500">*</span></label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full bg-transparent border-b border-gray-700 text-white py-3 focus:border-white transition-colors outline-none text-sm"
                />
              </div>
              <div>
                <label className="text-white text-sm mb-2 block">E-mail<span className="text-red-500">*</span></label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full bg-transparent border-b border-gray-700 text-white py-3 focus:border-white transition-colors outline-none text-sm"
                />
              </div>
              <div>
                <label className="text-white text-sm mb-2 block">Contact phone<span className="text-red-500">*</span></label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full bg-transparent border-b border-gray-700 text-white py-3 focus:border-white transition-colors outline-none text-sm"
                />
              </div>
              <div>
                <label className="text-white text-sm mb-2 block">Message<span className="text-red-500">*</span></label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={4}
                  className="w-full bg-transparent border-b border-gray-700 text-white py-3 focus:border-white transition-colors outline-none resize-none text-sm"
                />
              </div>
              <button
                type="submit"
                className="bg-white text-black px-10 py-3 text-sm tracking-[0.2em] hover:bg-gray-200 transition-colors font-medium"
              >
                Make an Appointment
              </button>
            </form>
          </div>

          {/* Instagram Grid */}
          <div>
            <a
              href={siteInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white text-base mb-8 block hover:text-gray-300 transition-colors"
            >
              Follow Us On Instagram
            </a>
            <div className="grid grid-cols-4 gap-2">
              {galleryImages.slice(0, 12).map((image, index) => (
                <div key={index} className="aspect-square overflow-hidden">
                  <img
                    src={image}
                    alt={`Instagram ${index + 1}`}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
